var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-eye-slash"}),_vm._v(" Results are hidden\n  "),_c('button',{staticClass:"btn btn-outline-dark btn-sm",on:{"click":_vm.showResult}},[_vm._v("\n    Show results\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }